import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { MotionValue, useMotionValue, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { useWindowSize } from 'react-use';
import { motion } from 'framer-motion';
import { useClientOnly } from '@/hooks/useClientOnly';
type ColorVariant = 'bg-blue-900' | 'bg-blue-700' | 'bg-blue-500' | 'bg-blue-100' | 'bg-blue-50' | 'bg-transparent' | 'bg-white';
const colors: Record<ColorVariant, string> = {
  'bg-blue-900': 'bg-blue-900',
  'bg-blue-700': 'bg-blue-700',
  'bg-blue-500': 'bg-blue-500',
  'bg-blue-100': 'bg-blue-100',
  'bg-blue-50': 'bg-blue-50',
  'bg-transparent': 'bg-transparent',
  'bg-white': 'bg-white'
};
interface Props {
  ratio?: MotionValue<number>;
  color: ColorVariant;
  background: ColorVariant;
  className?: string;
  wrapperClassName?: string;
  zIndex?: 10 | 20 | 30 | 40 | 50;
}
const MAX_HEIGHT = 120;
const SPACING = 20;
export const DEFAULT_RATIO = 0.06;
export function SectionDelimiter(props) {
  const $ = _c(37);
  const defaultRatio = useMotionValue(0.06);
  const {
    color,
    background,
    className,
    zIndex: t0,
    ratio: t1
  } = props;
  const zIndex = t0 === undefined ? 10 : t0;
  const ratio = t1 === undefined ? defaultRatio : t1;
  const {
    width
  } = useWindowSize();
  const ref = useRef(null);
  const {
    isClient
  } = useClientOnly();
  const t2 = isClient ? ref : undefined;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      target: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [-10, 0];
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  const scroll = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[4] !== width) {
    t6 = value => Math.min(MAX_HEIGHT, value * width);
    $[4] = width;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const height = useTransform(ratio, t6);
  let t7;
  if ($[6] !== width) {
    t7 = value_0 => width * width / (8 * value_0) * 2;
    $[6] = width;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const circleSize = useTransform(height, t7);
  const heightWithSpacing = useTransform(height, _temp);
  const y = useTransform(heightWithSpacing, _temp2);
  const borderRadius = useTransform(circleSize, _temp3);
  if (!isClient) {
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <></>;
      $[8] = t8;
    } else {
      t8 = $[8];
    }
    return t8;
  }
  let t8;
  if ($[9] !== heightWithSpacing) {
    t8 = {
      height: heightWithSpacing,
      position: "relative"
    };
    $[9] = heightWithSpacing;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== props.wrapperClassName) {
    t9 = mergeClasses("-mt-[1px]", props.wrapperClassName);
    $[11] = props.wrapperClassName;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `absolute w-full z-${zIndex}`;
  const t11 = colors[background];
  let t12;
  if ($[13] !== t10 || $[14] !== t11) {
    t12 = mergeClasses(t10, t11);
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== heightWithSpacing || $[17] !== y) {
    t13 = {
      height: heightWithSpacing,
      y,
      top: heightWithSpacing
    };
    $[16] = heightWithSpacing;
    $[17] = y;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = colors[color];
  let t15;
  if ($[19] !== className || $[20] !== t14) {
    t15 = mergeClasses("absolute top-4", t14, className);
    $[19] = className;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== borderRadius || $[23] !== circleSize || $[24] !== scroll) {
    t16 = {
      width: circleSize,
      height: circleSize,
      borderRadius,
      left: "50%",
      x: "-50%",
      y: scroll
    };
    $[22] = borderRadius;
    $[23] = circleSize;
    $[24] = scroll;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = <motion.div className={t15} style={t16} />;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t17) {
    t18 = <motion.div className={t12} ref={ref} style={t13}>{t17}</motion.div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t18 || $[34] !== t8 || $[35] !== t9) {
    t19 = <div className="overflow-hidden"><motion.div style={t8} className={t9}>{t18}</motion.div></div>;
    $[33] = t18;
    $[34] = t8;
    $[35] = t9;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
}
function _temp3(value_3) {
  return value_3 * Math.PI;
}
function _temp2(value_2) {
  return -value_2;
}
function _temp(value_1) {
  return value_1 + SPACING;
}